import { isArray } from 'util';
import { UserActivityBuilder } from './user-activity.builder';
import { RoleUserActivity } from '../role-user-activity';

export class RoleUserActivityBuilder {
  static fromJson(json) {
    return (json)
      ? new RoleUserActivity(
        json.code,
        json.name,
        UserActivityBuilder.fromJson(json.userActivity),
        json.userActivityName
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(RoleUserActivityBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/role-user-activity.builder.ts